import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=9b1efa1c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b1efa1c')) {
      api.createRecord('9b1efa1c', component.options)
    } else {
      api.reload('9b1efa1c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=9b1efa1c&", function () {
      api.rerender('9b1efa1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iPCjFaz55Qwg/JS/comp/ImgFallback.vue"
export default component.exports